// export const supportedLanguages = ['es', 'en' ];
export const supportedLanguages = ['es', 'en'];